import { CollectionData, PaginationResults } from "@/lib/type";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithLogout } from "@/lib/baseQuery";
import {
  StockAdjustment,
  StockAdjustmentReason,
} from "./inventory.type";

export interface GetStockAdjustmentsParams {
  page?: number;
  limit?: number;
  reason?: StockAdjustmentReason;
  ingredientUuid?: string;
  orderUuid?: string;
  adjustedByUuid?: string;
  from?: string;
  to?: string;
  sortDirection?: "asc" | "desc";
}

export const StockAdjustmentApi = createApi({
  reducerPath: "stockAdjustmentApi",
  tagTypes: ["stockAdjustment"],
  baseQuery: baseQueryWithLogout,
  endpoints: (build) => ({
    getStockAdjustments: build.query<
      PaginationResults<StockAdjustment>,
      { query?: GetStockAdjustmentsParams }
    >({
      query: ({ query }) => {
        const params: Record<string, string | number> = {};
        if (query?.page !== undefined) params.page = query.page;
        if (query?.limit !== undefined) params.limit = query.limit;
        if (query?.reason) params.reason = query.reason;
        if (query?.ingredientUuid)
          params["ingredient.uuid"] = query.ingredientUuid;
        if (query?.orderUuid) params["order.uuid"] = query.orderUuid;
        if (query?.adjustedByUuid)
          params["adjustedBy.uuid"] = query.adjustedByUuid;
        if (query?.from) params["createdAt[after]"] = query.from;
        if (query?.to) params["createdAt[before]"] = query.to;
        if (query?.sortDirection)
          params["order[createdAt]"] = query.sortDirection;
        return {
          url: `stock_adjustments`,
          method: "GET",
          params,
        };
      },
      providesTags: ["stockAdjustment"],
      transformResponse: (data: CollectionData<StockAdjustment>) => ({
        results: data["hydra:member"],
        count: data["hydra:totalItems"],
      }),
    }),

    getStockAdjustment: build.query<StockAdjustment, { uuid: string }>({
      query: ({ uuid }) => `stock_adjustments/${uuid}`,
      providesTags: ["stockAdjustment"],
    }),
  }),
});

export const {
  useGetStockAdjustmentsQuery,
  useGetStockAdjustmentQuery,
} = StockAdjustmentApi;
